/**
 * Returns the Guatemala states list to populate the select item.
 */
 export function gluky_addressfield_gt_states_list() {
  let temporalStates = [];
  const states = {
    '10': 'Alta Verapaz',
    '11': 'Baja Verapaz',
    '12': 'Chimaltenango',
    '15': 'Chiquimula',
    '17': 'El Progreso',
    '20': 'Escuintla',
    '25': 'Guatemala',
    '28': 'Huehuetenango',
    '30': 'Izabal',
    '35': 'Jalapa',
    '40': 'Jutiapa',
    '45': 'Petén',
    '50': 'Quetzaltenango',
    '55': 'Quiché',
    '60': 'Retalhuleu',
    '65': 'Sacatepéquez',
    '70': 'San Marcos',
    '75': 'Santa Rosa',
    '80': 'Sololá',
    '85': 'Suchitepéquez',
    '90': 'Totonicapán',
    '95': 'Zacapa',
  }
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Guatemala cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The state code
 * @return
 */
 export function gluky_addressfield_gt_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '10':
    {
      '10100': 'Cahabón',
      '10101': 'Chahal',
      '10102': 'Chisec',
      '10103': 'Cobán',
      '10104': 'Fray Bartolomé de las Casas',
      '10105': 'Lanquín',
      '10106': 'Panzós',
      '10107': 'Raxruhá',
      '10108': 'San Cristóbal Verapaz',
      '10109': 'San Juan Chamelco',
      '10110': 'San Pedro Carchá',
      '10111': 'Santa Catalina La Tinta',
      '10112': 'Santa Cruz Verapaz',
      '10113': 'Senahú',
      '10114': 'Tactic',
      '10115': 'Tamahú',
      '10116': 'Tucurú',
    },
    '11':
    {
      '11117': 'Cubulco',
      '11118': 'Granados',
      '11119': 'Purulhá',
      '11120': 'Rabinal',
      '11121': 'Salamá',
      '11122': 'San Jerónimo',
      '11123': 'San Miguel Chicaj',
      '11124': 'Santa Cruz el Chol',
    },
    '12':
    {
      '12125': 'Acatenango',
      '12126': 'Chimaltenango',
      '12127': 'El Tejar',
      '12128': 'Parramos',
      '12129': 'Patzicía',
      '12130': 'Patzún',
      '12131': 'Pochuta',
      '12132': 'San Andrés Itzapa',
      '12133': 'San José Poaquíl',
      '12134': 'San Juan Comalapa',
      '12135': 'San Martín Jilotepeque',
      '12136': 'San Pedro Yepocapa',
      '12137': 'Santa Apolonia',
      '12138': 'Santa Cruz Balanyá',
      '12139': 'Tecpán Guatemala',
      '12140': 'Zaragoza',
    },
    '15':
    {
      '15141': 'Camotán',
      '15142': 'Chiquimula',
      '15143': 'Concepción Las Minas',
      '15144': 'Esquipulas',
      '15145': 'Ipala',
      '15146': 'Jocotán',
      '15147': 'Olopa',
      '15148': 'Quezaltepeque',
      '15149': 'San Jacinto',
      '15150': 'San José La Arada',
      '15151': 'San Juan Ermita',
    },
    '17':
    {
      '17152': 'El Jícaro',
      '17153': 'Guastatoya',
      '17154': 'Morazán',
      '17155': 'San Agustín Acasaguastlán',
      '17156': 'San Antonio La Paz',
      '17157': 'San Cristóbal Acasaguastlán',
      '17158': 'Sanarate',
      '17159': 'Sansare',
    },
    '20':
    {
      '20160': 'Escuintla',
      '20161': 'Guanagazapa',
      '20162': 'Iztapa',
      '20163': 'La Democracia',
      '20164': 'La Gomera',
      '20165': 'Masagua',
      '20166': 'Nueva Concepción',
      '20167': 'Palín',
      '20168': 'Puerto San José',
      '20169': 'San Vicente Pacaya',
      '20170': 'Santa Lucía Cotzumalguapa',
      '20171': 'Siquinalá',
      '20172': 'Tiquisate',
    },
    '25':
    {
      '25173': 'Amatitlán',
      '25174': 'Chinautla',
      '25175': 'Chuarrancho',
      '25176': 'Fraijanes',
      '25177': 'Guatemala',
      '25178': 'Mixco',
      '25179': 'Palencia',
      '25180': 'San José del Golfo',
      '25181': 'San José Pinula',
      '25182': 'San Juan Sacatepéquez',
      '25183': 'San Miguel Petapa',
      '25184': 'San Pedro Ayampuc',
      '25185': 'San Pedro Sacatepéquez',
      '25186': 'San Raymundo',
      '25187': 'Santa Catarina Pinula',
      '25188': 'Villa Canales',
      '25189': 'Villa Nueva',
    },
    '28':
    {
      '28190': 'Aguacatán',
      '28191': 'Chiantla',
      '28192': 'Colotenango',
      '28193': 'Concepción Huista',
      '28194': 'Cuilco',
      '28195': 'Huehuetenango',
      '28196': 'Jacaltenango',
      '28197': 'La Democracia',
      '28198': 'La Libertad',
      '28199': 'Malacatancito',
      '28200': 'Nentón',
      '28201': 'San Antonio Huista',
      '28202': 'San Gaspar Ixchil',
      '28203': 'San Ildefonso Ixtahuacán',
      '28204': 'San Juan Atitán',
      '28205': 'San Juan Ixcoy',
      '28206': 'San Mateo Ixtatán',
      '28207': 'San Miguel Acatán',
      '28208': 'San Pedro Necta',
      '28209': 'San Pedro Soloma',
      '28210': 'San Rafael La Independencia',
      '28211': 'San Rafael Petzal',
      '28212': 'San Sebastián Coatán',
      '28213': 'San Sebastián Huehuetenango',
      '28214': 'Santa Ana Huista',
      '28215': 'Santa Bárbara',
      '28216': 'Santa Cruz Barillas',
      '28217': 'Santa Eulalia',
      '28218': 'Santiago Chimaltenango',
      '28219': 'Tectitán',
      '28220': 'Todos Santos Cuchumatán',
      '28221': 'Unión Cantinil',
    },
    '30':
    {
      '30222': 'El Estor',
      '30223': 'Livingston',
      '30224': 'Los Amates',
      '30225': 'Morales',
      '30226': 'Puerto Barrios',
    },
    '35':
    {
      '35227': 'Jalapa',
      '35228': 'Mataquescuintla',
      '35229': 'Monjas',
      '35230': 'San Carlos Alzatate',
      '35231': 'San Luis Jilotepeque',
      '35232': 'San Manuel Chaparrón',
      '35233': 'San Pedro Pinula',
    },
    '40':
    {
      '40234': 'Agua Blanca',
      '40235': 'Asunción Mita',
      '40236': 'Atescatempa',
      '40237': 'Comapa',
      '40238': 'Conguaco',
      '40239': 'El Adelanto',
      '40240': 'El Progreso',
      '40241': 'Jalpatagua',
      '40242': 'Jeréz',
      '40243': 'Jutiapa',
      '40244': 'Moyuta',
      '40245': 'Pasaco',
      '40246': 'Quesada',
      '40247': 'San José Acatempa',
      '40248': 'Santa Catarina Mita',
      '40249': 'Yupiltepeque',
      '40250': 'Zapotitlán',
    },
    '45':
    {
      '45251': 'Dolores',
      '45252': 'Flores',
      '45253': 'La Libertad',
      '45254': 'Melchor de Mencos',
      '45255': 'Poptún',
      '45256': 'San Andrés',
      '45257': 'San Benito',
      '45258': 'San Francisco',
      '45259': 'San José',
      '45260': 'San Luis',
      '45261': 'Santa Ana',
      '45262': 'Sayaxché',
    },
    '50':
    {
      '50263': 'Almolonga',
      '50264': 'Cabricán',
      '50265': 'Cajolá',
      '50266': 'Cantel',
      '50267': 'Coatepeque',
      '50268': 'Colomba',
      '50269': 'Concepción Chiquirichapa',
      '50270': 'El Palmar',
      '50271': 'Flores Costa Cuca',
      '50272': 'Génova',
      '50273': 'Huitán',
      '50274': 'La Esperanza',
      '50275': 'Olintepeque',
      '50276': 'Palestina de Los Altos',
      '50277': 'Quetzaltenango',
      '50278': 'Salcajá',
      '50279': 'San Carlos Sija',
      '50280': 'San Francisco La Unión',
      '50281': 'San Juan Ostuncalco',
      '50282': 'San Martín Sacatepéquez',
      '50283': 'San Mateo',
      '50284': 'San Miguel Sigüilá',
      '50285': 'Sibilia',
      '50286': 'Zunil',
    },
    '55':
    {
      '55287': 'Canillá',
      '55288': 'Chajul',
      '55289': 'Chicamán',
      '55290': 'Chiché',
      '55291': 'Chichicastenango',
      '55292': 'Chinique',
      '55293': 'Cunén',
      '55294': 'Ixcán',
      '55295': 'Joyabaj',
      '55296': 'Nebaj',
      '55297': 'Pachalum',
      '55298': 'Patzité',
      '55299': 'Sacapulas',
      '55300': 'San Andrés Sajcabajá',
      '55301': 'San Antonio Ilotenango',
      '55302': 'San Bartolomé Jocotenango',
      '55303': 'San Juan Cotzal',
      '55304': 'San Pedro Jocopilas',
      '55305': 'Santa Cruz del Quiché',
      '55306': 'Uspantán',
      '55307': 'Zacualpa',
    },
    '60':
    {
      '60308': 'Champerico',
      '60309': 'El Asintal',
      '60310': 'Nuevo San Carlos',
      '60311': 'Retalhuleu',
      '60312': 'San Andrés Villa Seca',
      '60313': 'San Felipe',
      '60314': 'San Martín Zapotitlán',
      '60315': 'San Sebastián',
      '60316': 'Santa Cruz Muluá',
    },
    '65':
    {
      '65317': 'Alotenango',
      '65318': 'Antigua Guatemala',
      '65319': 'Ciudad Vieja',
      '65320': 'Jocotenango',
      '65321': 'Magdalena Milpas Altas',
      '65322': 'Pastores',
      '65323': 'San Antonio Aguas Calientes',
      '65324': 'San Bartolomé Milpas Altas',
      '65325': 'San Lucas Sacatepéquez',
      '65326': 'San Miguel Dueñas',
      '65327': 'Santa Catarina Barahona',
      '65328': 'Santa Lucía Milpas Altas',
      '65329': 'Santa María de Jesús',
      '65330': 'Santiago Sacatepéquez',
      '65331': 'Santo Domingo Xenacoj',
      '65332': 'Sumpango',
    },
    '70':
    {
      '70333': 'Ayutla',
      '70334': 'Catarina',
      '70335': 'Comitancillo',
      '70336': 'Concepción Tutuapa',
      '70337': 'El Quetzal',
      '70338': 'El Rodeo',
      '70339': 'El Tumbador',
      '70340': 'Esquipulas Palo Gordo',
      '70341': 'Ixchiguán',
      '70342': 'La Reforma',
      '70343': 'Malacatán',
      '70344': 'Nuevo Progreso',
      '70345': 'Ocós',
      '70346': 'Pajapita',
      '70347': 'Río Blanco',
      '70348': 'San Antonio Sacatepéquez',
      '70349': 'San Cristóbal Cucho',
      '70350': 'San José Ojetenam',
      '70351': 'San Lorenzo',
      '70352': 'San Marcos',
      '70353': 'San Miguel Ixtahuacán',
      '70354': 'San Pablo',
      '70355': 'San Pedro Sacatepéquez',
      '70356': 'San Rafaél Pie de La Cuesta',
      '70357': 'Sibinal',
      '70358': 'Sipacapa',
      '70359': 'Tacaná',
      '70360': 'Tajumulco',
      '70361': 'Tejutla',
    },
    '75':
    {
      '75362': 'Barberena',
      '75363': 'Casillas',
      '75364': 'Chiquimulilla',
      '75365': 'Cuilapa',
      '75366': 'Guazacapán',
      '75367': 'Nueva Santa Rosa',
      '75368': 'Oratorio',
      '75369': 'Pueblo Nuevo Viñas',
      '75370': 'San Juan Tecuaco',
      '75371': 'San Rafaél Las Flores',
      '75372': 'Santa Cruz Naranjo',
      '75373': 'Santa María Ixhuatán',
      '75374': 'Santa Rosa de Lima',
      '75375': 'Taxisco',
    },
    '80':
    {
      '80376': 'Concepción',
      '80377': 'Nahualá',
      '80378': 'Panajachel',
      '80379': 'San Andrés Semetabaj',
      '80380': 'San Antonio Palopó',
      '80381': 'San José Chacayá',
      '80382': 'San Juan La Laguna',
      '80383': 'San Lucas Tolimán',
      '80384': 'San Marcos La Laguna',
      '80385': 'San Pablo La Laguna',
      '80386': 'San Pedro La Laguna',
      '80387': 'Santa Catarina Ixtahuacan',
      '80388': 'Santa Catarina Palopó',
      '80389': 'Santa Clara La Laguna',
      '80390': 'Santa Cruz La Laguna',
      '80391': 'Santa Lucía Utatlán',
      '80392': 'Santa María Visitación',
      '80393': 'Santiago Atitlán',
      '80394': 'Sololá',
    },
    '85':
    {
      '85395': 'Chicacao',
      '85396': 'Cuyotenango',
      '85397': 'Mazatenango',
      '85398': 'Patulul',
      '85399': 'Pueblo Nuevo',
      '85400': 'Río Bravo',
      '85401': 'Samayac',
      '85402': 'San Antonio Suchitepéquez',
      '85403': 'San Bernardino',
      '85404': 'San Francisco Zapotitlán',
      '85405': 'San Gabriel',
      '85406': 'San José El Ídolo',
      '85407': 'San Juan Bautista',
      '85408': 'San Lorenzo',
      '85409': 'San Miguel Panán',
      '85410': 'San Pablo Jocopilas',
      '85411': 'Santa Barbara',
      '85412': 'Santo Domingo Suchitepequez',
      '85413': 'Santo Tomas La Unión',
      '85414': 'Zunilito',
    },
    '90':
    {
      '90415': 'Momostenango',
      '90416': 'San Andrés Xecul',
      '90417': 'San Bartolo',
      '90418': 'San Cristóbal Totonicapán',
      '90419': 'San Francisco El Alto',
      '90420': 'Santa Lucía La Reforma',
      '90421': 'Santa María Chiquimula',
      '90422': 'Totonicapán',
    },
    '95':
    {
      '95423': 'Cabañas',
      '95424': 'Estanzuela',
      '95425': 'Gualán',
      '95426': 'Huité',
      '95427': 'La Unión',
      '95428': 'Río Hondo',
      '95429': 'San Diego',
      '95430': 'Teculután',
      '95431': 'Usumatlán',
      '95432': 'Zacapa',
    }
  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}
